import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=4225ae4d&"
import script from "./CommentList.vue?vue&type=script&lang=ts&"
export * from "./CommentList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList})
